import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "",
  for: "page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: undefined }, null, -1)
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('manuscripts.choose_page')), 1),
    _withDirectives(_createElementVNode("select", {
      class: "ml-2 w-full md:w-min bg-blue-light border",
      name: "page",
      id: "page",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
    }, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: page.page_id,
          value: index
        }, _toDisplayString(`${page.folio}${page.side ? page.side : ""}${
            page.passages.length === 0
              ? ''
              : ', ' + page.passages.map((p) => _ctx.toText(p)).join(', ')
          }`), 9, _hoisted_3))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.selected]
    ])
  ]))
}